import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
@Injectable({
	providedIn: 'root'
})
export class FormBuilderService {
	baseUrl: string;
	private settings: Subject<any> = new Subject<any>();
	private clone: Subject<any> = new Subject<any>();
	private delete: Subject<any> = new Subject<any>();
	private modelDropped: Subject<any> = new Subject<any>();
	private modeSetted: Subject<any> = new Subject<any>();
	private autoSaved: Subject<any> = new Subject<any>();

	private childGroup: Subject<any> = new Subject<any>();
	renderForm: Subject<any> = new Subject<any>();
	renderForm$ = this.renderForm.asObservable();
	constructor(private _httpClient: HttpClient) {
		this.baseUrl = environment.API_SERVER;
	}

	setRender(org): void {
		this.renderForm.next(org);
	}

	setAutoSaved(org): void {
		this.autoSaved.next(org);
	}

	getAutoSaved(): Observable<any> {
		return this.autoSaved.asObservable();
	}

	setChildGroup(org): void {
		this.childGroup.next(org);
	}

	getChildGroup(): Observable<any> {
		return this.childGroup.asObservable();
	}

	setModeSetted(org): void {
		this.modeSetted.next(org);
	}

	getModeSetted(): Observable<any> {
		return this.modeSetted.asObservable();
	}

	setModelDroppeds(org): void {
		this.modelDropped.next(org);
	}

	getModelDropped(): Observable<any> {
		return this.modelDropped.asObservable();
	}

	setSettings(org): void {
		this.settings.next(org);
	}

	getSettings(): Observable<any> {
		return this.settings.asObservable();
	}
	setClone(org): void {
		this.clone.next(org);
	}

	getClone(): Observable<any> {
		return this.clone.asObservable();
	}

	setDelete(org): void {
		this.delete.next(org);
	}

	getDelete(): Observable<any> {
		return this.delete.asObservable();
	}

	// Form Builder Api Organization
	getOrganizationFormBuilder(organizationId, appUserEmail) {
		return this._httpClient
			.get(`${this.baseUrl}/api/v2/organizations/${organizationId}/users/${appUserEmail}/form_builders/`)
			.pipe(map((res: any) => res.json()));
	}

	cloneOrganizationFormBuilder(organizationId, appUserEmail, formBuilderId, body) {
		return this._httpClient.post(
			`${this
				.baseUrl}/api/v2/organizations/${organizationId}/users/${appUserEmail}/form_builders/${formBuilderId}/duplicate/`,
			body
		);
	}

	addOrganizationFormBuilder(organizationId, appUserEmail, body) {
		return this._httpClient.post(
			`${this.baseUrl}/api/v2/organizations/${organizationId}/users/${appUserEmail}/form_builders/`,
			body
		);
	}

	editOrganizationFormBuilder(organizationId, appUserEmail, formBuilderId, body) {
		return this._httpClient.put(
			`${this
				.baseUrl}/api/v2/organizations/${organizationId}/users/${appUserEmail}/form_builders/${formBuilderId}/`,
			body
		);
	}

	deleteOrganizationFormBuilder(organizationId, appUserEmail, formBuilderId) {
		return this._httpClient.delete(
			`${this
				.baseUrl}/api/v2/organizations/${organizationId}/users/${appUserEmail}/form_builders/${formBuilderId}/`
		);
	}

	deleteOrganizationFormBuilderVersion(organizationId, appUserEmail, formBuilderId) {
		return this._httpClient.delete(
			`${this
				.baseUrl}/api/v2/organizations/${organizationId}/users/${appUserEmail}/form_builders_versions/${formBuilderId}/`
		);
	}

	// Form Builder Api  User
	getUserFormBuilder(appUserEmail) {
		return this._httpClient
			.get(`${this.baseUrl}/api/v2/users/${appUserEmail}/form_builders/`)
			.pipe(map((res: any) => res.json()));
	}

	cloneUserFormBuilder(appUserEmail, formBuilderId, body) {
		return this._httpClient.post(
			`${this.baseUrl}/api/v2/users/${appUserEmail}/form_builders/${formBuilderId}/duplicate/`,
			body
		);
	}

	updateUserFormBuilder(appUserEmail, formBuilderVersionId, body) {
		return this._httpClient.put(
			`${this.baseUrl}/api/v2/users/${appUserEmail}/form_builders_versions/${formBuilderVersionId}/`,
			body
		);
	}

	updateOrganizationFormBuilder(organizationId, appUserEmail, formBuilderVersionId, body) {
		return this._httpClient.put(
			`${this
				.baseUrl}/api/v2/organizations/${organizationId}/users/${appUserEmail}/form_builders_versions/${formBuilderVersionId}/`,
			body
		);
	}
	addUserFormBuilder(appUserEmail, body) {
		return this._httpClient.post(`${this.baseUrl}/api/v2/users/${appUserEmail}/form_builders/`, body);
	}

	editUserFormBuilder(appUserEmail, formBuilderId, body) {
		return this._httpClient.put(
			`${this.baseUrl}/api/v2/users/${appUserEmail}/form_builders/${formBuilderId}/`,
			body
		);
	}

	deleteUserFormBuilder(appUserEmail, formBuilderId) {
		return this._httpClient.delete(`${this.baseUrl}/api/v2/users/${appUserEmail}/form_builders/${formBuilderId}/`);
	}

	deleteUserFormBuilderVersion(appUserEmail, formBuilderId) {
		return this._httpClient.delete(
			`${this.baseUrl}/api/v2/users/${appUserEmail}/form_builders_versions/${formBuilderId}/`
		);
	}

	getUserFormBuilderVersions(appUserEmail, formBuilderId) {
		return this._httpClient
			.get(`${this.baseUrl}/api/v2/users/${appUserEmail}/form_builders/${formBuilderId}/form_builders_versions/`)
			.pipe(map((res: any) => res.json()));
	}

	getOrganizationFormBuilderVersions(organizationId, appUserEmail, formBuilderId): Observable<any> {
		return this._httpClient
			.get(
				`${this
					.baseUrl}/api/v2/organizations/${organizationId}/users/${appUserEmail}/form_builders/${formBuilderId}/form_builders_versions/`
			)
			.pipe(map((res: any) => res.json()));
	}

	// FORM TEMPLATEs
	getFormTemplates() {
		return this._httpClient.get(`${this.baseUrl}/form_templates/`).pipe(map((res: any) => res.json()));
	}
	getFormTemplate(payload): Observable<any> {
		return this._httpClient
			.get(`${this.baseUrl}/form_templates/${payload.formTemplateId}/`)
			.pipe(map((res: any) => res.json()));
	}

	addFormTemplate(payload) {
		return this._httpClient.post(`${this.baseUrl}/form_templates/`, payload.body);
	}

	addFormThruTemplate(payload) {
		return this._httpClient.post(
			`${this.baseUrl}/form_templates/${payload.formTemplateId}/projects/${payload.projectId}/forms/`,
			payload.body
		);
	}

	updateFormTemplate(payload) {
		return this._httpClient.put(`${this.baseUrl}/form_templates/${payload.formTemplateId}/`, payload.body);
	}

	updateFormTemplateStatus(payload) {
		return this._httpClient.put(
			`${this.baseUrl}/form_templates/${payload.formTemplateId}/publish/${payload.status}/`,
			payload.body
		);
	}

	deleteFormTemplate(payload) {
		return this._httpClient.delete(`${this.baseUrl}/form_templates/${payload.formTemplateId}/`);
	}
}
